import { useMemo } from 'react';
import { IconType } from 'react-icons';
import { useBuyersMarketCart } from 'hooks/useBuyersMarketCart';
import HeaderBadge from './HeaderBadge';

const CartHeaderBadge = ({ Icon }: { Icon: IconType }) => {
  const { cartGroupCases } = useBuyersMarketCart();
  const badgeContent = useMemo(() => cartGroupCases.toString(), [cartGroupCases]);

  return <HeaderBadge Icon={Icon} badgeContent={badgeContent} />;
};

export default CartHeaderBadge;
